import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  label: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
    color: '#333333',
  },
  value: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
  }
}));

export default function KeyInformationItem({ label, value }) {
  const classes = useStyles();

  return (
    <Grid container direction='row' spacing={1}>
      <Grid item>
        <Typography
          variant="body1"
          component="span"
          className={classes.label}
          gutterBottom
        >
          { label }:
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          variant="body1"
          component="span"
          className={classes.value}
          gutterBottom
        >
          { value }
        </Typography>
      </Grid>
    </Grid>
  );
};
